import $ from 'jquery';
import init from '../init';

export default function newsPage() {
  const NEWS_ARTICLE_CONTAINER = $('#news-articles');

  if (NEWS_ARTICLE_CONTAINER.length) {
    // const grid = NEWS_ARTICLE_CONTAINER.querySelector('.grid');
    const button = $('#load');
    const url = button.prop('href');

    setupLoad(button, url);
  }
}

function setupLoad(button, url) {
  const parent = $(button).parent();

  $(button).on('click', function (e) {
    e.preventDefault();
    parent.prop('style', 'opacity: 0');

    $.ajax(url).done(function(data) {
      const html = $(data);
      const grid = html.find('#news-articles .grid');
      const button = html.find('#news-articles #load');
      const container = $('#news-articles');

      init(grid);
      $('#news-articles .grid').append(grid.html());

      parent.remove();
      if (button.length) {
        const buttonUrl = button.prop('href');
        const buttonParent = button.parent();
        container.append(buttonParent);
        setupLoad(button, buttonUrl);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./source/scripts/pages/news.js